import axios from 'axios';

export default class AuthorsService
{
    public static async getList(filter: FilterModel, pager: Pager)
    {
        return (await axios.get<Pagination<Resource<ListItemModel>>>('admin/cms/authors', {
            params: { ...filter, ...pager.data() }
        })).data;
    }

    public static async fetch(id: number)
    {
        return (await axios.get<Resource<FormModel>>(`admin/cms/authors/${id}`)).data;
    }

    public static async fetchDefault()
    {
        return (await axios.get<Resource<FormModel>>(`admin/cms/authors/default`)).data;
    }

    public static async fetchByUser()
    {
        return (await axios.get<Resource<FormModel>>(`admin/cms/authors/user`)).data;
    }

    public static async create(model: FormModel)
    {
        return (await axios.post<Resource<FormModel>>(`admin/cms/authors`, model)).data;
    }

    public static async update(id: number, model: FormModel)
    {
        return (await axios.put<Resource<FormModel>>(`admin/cms/authors/${id}`, model)).data;
    }

    public static async remove(id: number)
    {
        return (await axios.delete(`admin/cms/authors/${id}`)).data as Statement;
    }

    public static async getAutocompleteList(search: string, limit: number = 10, websiteId: number = null, locale: string = null, excluded: number[] = [])
    {
        return (await axios.get<ListItemModel[]>('admin/cms/authors/autocomplete', {
            params: {
                search: search,
                limit: limit,
                websiteId: websiteId,
                locale: locale,
                excluded: excluded
            }
        })).data;
    }

    public static async fetchAutocompleteModel(id: number)
    {
        return (await axios.get<ListItemModel>(`admin/cms/authors/autocomplete/${id}`)).data;
    }

    public static async getAllAuthorsList(filter: FilterModel): Promise<Pagination<Resource<ListItemModel>>>
    {
        return (await axios.get<Pagination<Resource<ListItemModel>>>('admin/cms/authors/sort', {
            params: { ...filter }
        })).data;
    }

    public static async sortAuthors(positions: PagePosition[])
    {
        return (await axios.put<Statement>(`admin/cms/authors/sort/positions`, positions)).data;
    }

    public static async fetchEditor()
    {
        return (await axios.get<EditorFormModel>(`admin/cms/authors/editor`)).data;
    }

    public static async updateEditor(model: EditorFormModel)
    {
        return (await axios.post<EditorFormModel>(`admin/cms/authors/editor`, model)).data;
    }

    public static async getListByArticleId(articleId: number)
    {
        return (await axios.get<ListItemModel[]>(`admin/cms/authors/articles/${articleId}`)).data;
    }

    public static async getListByIds(ids: number[])
    {
        return (await axios.get<ListItemModel[]>(`admin/cms/authors/ids`, {
            params: {
                ids: ids
            }
        })).data;
    }
}

export interface ListItemModel
{
    authorType: string;
    facePicture?: File;
    id: number;
    isExistingUser: boolean;
    isPulished: boolean;
    position?: number;
    userName: string;
    websiteName: string;
    facePictureUrl: string;
}

export interface FilterModel
{
    locale: string;
    websiteId: number;
    userName?: string;
    isExistingUser?: boolean;
}

export interface FormModel
{
    authorType: string;
    description: string;
    facePicture?: File;
    id: number;
    isExistingUser: boolean;
    isPulished: boolean;
    locale: string;
    shortDescription: string;
    symbol: string;
    userId?: number;
    userName: string;
    websiteId: number;
}

export interface PagePosition
{
    id: number;
    position: number;
}

export interface EditorFormModel
{
    name: string;
    picture?: File;
    shortDescription: string;
}
